/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getClientDefaultTransportAsync } from './DataService/DataActionExtension.g';
import { IGetClientDefaultTransportResponse } from './DataService/DataServiceEntities.g';

/**
 * GetClientDefaultTransport Input Action
 */
export class GetClientDefaultTransportInput implements IActionInput {
    // Input properties
    public accountNum: number;

    constructor(accountNum: number | string) {
        this.accountNum = typeof accountNum === 'string' ? +accountNum : accountNum;
    }

    public getCacheKey = () => `GetClientDefaultTransportInput`;
    public getCacheObjectType = () => 'GetClientDefaultTransportInput';
    public dataCacheType = (): CacheType => 'none';
}

const createInput = (args: ICreateActionContext, accountNum: number | string): IActionInput => {
    return new GetClientDefaultTransportInput(accountNum);
};

export async function GetClientDefaultTransport(
    input: GetClientDefaultTransportInput,
    ctx: IActionContext
): Promise<IGetClientDefaultTransportResponse> {
    return getClientDefaultTransportAsync({ callerContext: ctx }, input.accountNum)
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-client-default-transport] Unable to load warehouse list');
            throw new Error('[get-client-default-transport] Unable to load warehouse list');
        });
}

export default createObservableDataAction({
    action: <IAction<IGetClientDefaultTransportResponse>>GetClientDefaultTransport,
    id: 'GetClientDefaultTransport',
    input: createInput
});
